export default __webpack_public_path__ + "static/media/landscaping-3.d75e17d3.webp";